import React from 'react';
import soundNotification from './soundNotification';
import { gettext } from '../i18n/service';
import _ from 'lodash';
import formatCamelCase from './formatCamelCase.js';

export function createOrder(data, showMessage, router, renderModalForDetails, addNewOrderToStore) {
  soundNotification.checkOrderAndPlayNotification(data.data);
  showMessage({
    level: 'success',
    children: (
      <span>
        {gettext('ORDER#') + ' '}
        <a onClick={() => renderModalForDetails(data.data)}>
          {data.data.id.slice(data.data.id.length - 5, data.data.id.length)}
        </a>
        {' ' + gettext('HAS-BEEN-CREATED')}
      </span>
    )
  });

  return addNewOrderToStore(data.data);
}

export function updateOrder(data, showMessage, router, renderModalForDetails, updateLocalOrder, orders, users, drivers) {
  soundNotification.checkOrderAndPlayNotification(data.data);
  const oldOrder = _.find(orders, { id: data.data.id });
  if (data.data.autoAssign === false) {
    showMessage({
      level: 'error',
      children: (
        <span>
          {gettext('AUTOASSIGNING-FOR-ORDER') + ' '}
          <a onClick={() => renderModalForDetails(data.data)}>
            {data.data.id.slice(data.data.id.length - 5, data.data.id.length)}
          </a>
          {' ' + gettext('FAILED')}
        </span>
      )
    });

    return updateLocalOrder(data.data, { autoAssign: 'fail' });
  } else if (data.data.driverId && data.data.orderStatus !== 'new' ) {
    if (oldOrder && oldOrder.driverId !== data.data.driverId) {  
      const driver = _.find(drivers, { id: data.data.driverId });
      if (driver)
        showMessage({
          level: 'success',
          children: (
            <span>
              {gettext('ORDER#') + ' '}
              <a onClick={() => renderModalForDetails(data.data)}>
                {data.data.id.slice(data.data.id.length - 5, data.data.id.length)}
              </a>
              {' ' + gettext('ASSIGNED-TO')}
              {' ' + driver.firstName}
            </span>
          )
        });
      else {
        showMessage({
          level: 'success',
          children: (
            <span>
              {gettext('ORDER#') + ' '}
              <a onClick={() => renderModalForDetails(data.data)}>
                {data.data.id.slice(data.data.id.length - 5, data.data.id.length)}
              </a>
              {' ' + gettext('ASSIGNED-TO')}
            </span>
          )
        });
      }
    }
  } else if (data.data.orderStatus === 'new' && data.data.driverId) {
    data.data.driverId = undefined;
    showMessage({
      level: 'success',
      children: (
        <span>
          {gettext('ORDER#') + ' '}
          <a onClick={() => renderModalForDetails(data.data)}>
            {data.data.id.slice(data.data.id.length - 5, data.data.id.length)}
          </a>
          {' ' + gettext('UNASSIGNED')}
        </span>
      )
    });
    return updateLocalOrder(data.data, { autoAssign: 'fail' });
  } else if (oldOrder && oldOrder.orderStatus !== data.data.orderStatus) {
    showMessage({
      level: 'success',
      children: (
        <span>
          {gettext('STATUS-FOR-ORDER') + ' '}
          {'#'}
          <a onClick={() => renderModalForDetails(data.data)}>
            {data.data.id.slice(data.data.id.length - 5, data.data.id.length)}
          </a>
          {' ' + gettext('HAVE-BEEN-CHANGED-TO') + ' '}
          {formatCamelCase(data.data.orderStatus)}
        </span>
      )
    });
  } else if (oldOrder && oldOrder.orderStatus === data.data.orderStatus) {
    showMessage({
      level: 'success',
      children: (
        <span>
          {gettext('ORDER#') + ' '}
          <a onClick={() => renderModalForDetails(data.data)}>
            {data.data.id.slice(data.data.id.length - 5, data.data.id.length)}
          </a>
          {' ' + gettext('HAS-BEEN-UPDATED')}
        </span>
      )
    });
  } else if (data.data.orderStatus === 'returned') {
    if (oldOrder && oldOrder.orderStatus !== data.data.orderStatus) {
      showMessage({
        level: 'success',
        children: (
          <span>
            {gettext('ORDER#') + ' '}
            <a onClick={() => renderModalForDetails(data.data)}>
              {data.data.id.slice(data.data.id.length - 5, data.data.id.length)}
            </a>
            {' ' + gettext('HAS-BEEN-RETURNED')}
          </span>
        )
      });
    }
  }  
  return updateLocalOrder(data.data);
}

export function connectionError(showMessage) {
  soundNotification.checkOrderAndPlayNotification({
    express: '',
    isOutOfCity: false
  });
  showMessage({
    title: gettext('ERROR-OCCURED'),
    level: 'error',
    children: (
      <span>
        Failed to establish connection to the server
      </span>
    )
  });
}

export function connectionSuccess(showMessage) {
  soundNotification.checkOrderAndPlayNotification({
    express: '',
    isOutOfCity: false
  });
  showMessage({
    title: 'Connection Established',
    level: 'success',
    children: (
      <span>
        Connection to the server successfully established
      </span>
    )
  });
}

export function createCard(data, showMessage) {
  soundNotification.checkOrderAndPlayNotification(data.data);
  let flag = 'success';
  const title = 'Credit Card Added';
  let mesasge = 'Credit Card details successfully added and validated';
  if(data.data.confirmed === false) {
    flag = 'error';
    mesasge = 'Credit Card Error';
  }
    
  return showMessage({
    title: title,
    level: flag,
    children: (
      <span>
        {mesasge}
      </span>
    )
  });
}

// export function createItem(data, showMessage, router, updateLocalOrder, orders) {
//   const order = _.find(this.props.orders, { id: data.data.orderId });
//   if (!order) {
//     return;
//   }
//   let orderItems = order.items || [];
//   if (_.some(order.items, { id: data.data.id })) {
//     return;
//   }
//   return updateLocalOrder(order, { items: orderItems.concat([data.data]) });
// }
//
// export function updateItem(data, showMessage, router, updateLocalOrder, orders) {
//   const order = _.find(orders, { id: data.data.orderId });
//
//   if (!order) {
//     return;
//   }
//
//   let orderItems = objectAssign([], order.items);
//   let item = _.find(orderItems, { id: data.data.id });
//   objectAssign(item, data.data);
//
//   return updateLocalOrder(order, { items: orderItems });
// }



// WEBPACK FOOTER //
// ./src/businessLogic/streamUpdateHelper.js